import "./DictionaryCard.css";
const DICTIONARY_API_URL = "https://api.ayesearch.com/api/dictionary/";

interface TranslationItem { language: string; language_name: string; word: string }
interface SenseItem { concept_key: string; english_gloss: string; definition: string }
interface DictionaryResponse {
  word?: string;
  language?: string;
  language_name?: string;
  phonetic?: string;
  part_of_speech?: string;
  definition?: string;
  english_gloss?: string;
  usage_note?: string;
  translations?: TranslationItem[];
  other_senses?: SenseItem[];
  error?: string;
}
export interface DictionaryCardOptions { language?: string }

function escapeHtml(v: unknown): string {
  return String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function translations(items?: TranslationItem[]): string {
  if (!items?.length) return "";
  return `<section class="dict-translations"><div class="dict-section-title">Translations</div><div class="dict-translation-grid">${items.map(i => `<div class="dict-translation-item"><span>${escapeHtml(i.language_name)}</span><strong dir="${i.language === "ar" ? "rtl" : "auto"}">${escapeHtml(i.word)}</strong></div>`).join("")}</div></section>`;
}
function senses(items?: SenseItem[]): string {
  if (!items?.length) return "";
  return `<section class="dict-senses"><div class="dict-section-title">Other meanings</div>${items.slice(0, 3).map(i => `<div class="dict-sense"><strong>${escapeHtml(i.english_gloss)}</strong><span>${escapeHtml(i.definition)}</span></div>`).join("")}</section>`;
}

export async function renderDictionaryCard(
  container: HTMLElement,
  query: string,
  options: DictionaryCardOptions = {},
): Promise<void> {
  container.innerHTML = `<section class="card-container dict-card dict-loading"><div class="dict-loading-line"></div><div class="dict-loading-word"></div><div class="dict-loading-line short"></div></section>`;
  try {
    const url = new URL(DICTIONARY_API_URL);
    url.searchParams.set("q", query);
    if (options.language) url.searchParams.set("language", options.language);
    const res = await fetch(url.toString(), { method: "GET", credentials: "include", headers: { Accept: "application/json" } });
    const ct = res.headers.get("content-type") || "";
    if (!ct.includes("application/json")) throw new Error(`Dictionary API returned HTTP ${res.status} with non-JSON response`);
    const data = (await res.json()) as DictionaryResponse;
    if (!res.ok || data.error || !data.word || !data.definition) throw new Error(data.error || `Dictionary API returned HTTP ${res.status}`);
    container.innerHTML = `<section class="card-container dict-card" aria-label="AyeSearch dictionary result"><div class="dict-kicker">AYESEARCH DICTIONARY · ${escapeHtml(data.language_name || "Dictionary")}</div><div class="dict-word-row"><div class="dict-word" dir="${data.language === "ar" ? "rtl" : "auto"}">${escapeHtml(data.word)}</div>${data.part_of_speech ? `<div class="dict-part">${escapeHtml(data.part_of_speech)}</div>` : ""}</div>${data.phonetic ? `<div class="dict-phonetic">${escapeHtml(data.phonetic)}</div>` : ""}<div class="dict-definition">${escapeHtml(data.definition)}</div>${data.usage_note ? `<div class="dict-note">${escapeHtml(data.usage_note)}</div>` : ""}${translations(data.translations)}${senses(data.other_senses)}<div class="dict-source">AyeSearch language database · deterministic result</div></section>`;
  } catch (error) {
    console.error("AyeSearch dictionary card failed:", error);
    container.innerHTML = `<section class="card-container dict-card"><div class="dict-definition">No definition found in the AyeSearch starter dictionary.</div></section>`;
  }
}
